






































import Vue from 'vue';
import moment from 'moment';
import CompactEvent from '@/web/components/events/CompactEvent.vue';
import HMButton from '@/web/components/common/HMButton.vue';

export default Vue.extend({
  name: 'StudioUpcomingEventModal',
  components: {
    HMButton,
    CompactEvent,
  },
  props: {
    event: {
      type: Object,
    },
    onClose: {
      type: Function,
    },
  },
  computed: {
    minutesToEvent() {
      const now = moment();
      const eventStart = moment(this.event.event_start_datetime);
      const duration = moment.duration(eventStart.diff(now));
      return parseInt(duration.asMinutes());
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      if (this.onClose) this.onClose();
      this.$emit('close');
    },
  },
});
